if (!customElements.get('yam-cart-recommendations')) {
  class YamCartRecommendations extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-yam-recommendation-viewport]');
      this.track = this.querySelector('[data-yam-recommendation-track]');
      this.status = this.querySelector('.yam-cart-recommendations__status');
      this.productIds = [...new Set((this.dataset.productIds || '').split(',').filter(Boolean))];

      this.querySelector('[data-yam-recommendation-prev]')?.addEventListener('click', () => this.navigate(-1));
      this.querySelector('[data-yam-recommendation-next]')?.addEventListener('click', () => this.navigate(1));
      this.viewport?.addEventListener('scroll', () => this.closeVariantMenus(), { passive: true });
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('click', (event) => this.onVariantMenuClick(event));
      this.addEventListener('click', (event) => this.onAdd(event));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeVariantMenus();
      });
      this.documentClickHandler = (event) => {
        if (!event.target.closest?.('.yam-cart-recommendation-card__select-wrap')) this.closeVariantMenus();
      };
      document.addEventListener('click', this.documentClickHandler);
      this.enhanceVariantSelectors();
      this.load();
    }

    disconnectedCallback() {
      this.closeVariantMenus();
      document.removeEventListener('click', this.documentClickHandler);
    }

    async load() {
      if (!this.track || !this.productIds.length) return;

      const uniqueCards = new Map();
      try {
        for (const productId of this.productIds.slice(0, 6)) {
          let cards = await this.fetchCards(productId, 'complementary');
          if (!cards.length) cards = await this.fetchCards(productId, 'related');

          cards.forEach((card) => {
            const id = card.dataset.productId;
            if (id && !uniqueCards.has(id)) uniqueCards.set(id, card);
          });
          if (uniqueCards.size >= 10) break;
        }

        if (!uniqueCards.size) return;
        this.track.replaceChildren(...uniqueCards.values());
        this.enhanceVariantSelectors();
        this.hidden = false;
      } catch (error) {
        console.warn('[YAM cart] Product recommendations unavailable', error);
      }
    }

    async fetchCards(productId, intent) {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(`${root}recommendations/products`, window.location.origin);
      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', '10');
      url.searchParams.set('intent', intent);
      url.searchParams.set('section_id', this.dataset.sectionId || 'yam-cart-recommendations');

      const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) return [];
      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      return [...documentFragment.querySelectorAll('.yam-cart-recommendation-card')].map((card) => card.cloneNode(true));
    }

    navigate(direction) {
      if (!this.viewport) return;
      const card = this.track?.querySelector('.yam-cart-recommendation-card');
      if (!card) return;
      const step = card.getBoundingClientRect().width + 12;
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      let target = this.viewport.scrollLeft + direction * step;
      if (direction > 0 && target > max - 2) target = 0;
      if (direction < 0 && target < 0) target = max;
      this.viewport.scrollTo({ left: target, behavior: 'smooth' });
    }

    enhanceVariantSelectors() {
      this.querySelectorAll('[data-yam-recommendation-variant]').forEach((select) => {
        const wrap = select.closest('.yam-cart-recommendation-card__select-wrap');
        if (!wrap || wrap.querySelector('[data-yam-variant-trigger]')) return;

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'yam-cart-recommendation-card__variant-trigger';
        trigger.setAttribute('data-yam-variant-trigger', '');
        trigger.setAttribute('aria-haspopup', 'listbox');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-label', select.getAttribute('aria-label') || 'Choisir une variante');

        const label = document.createElement('span');
        label.className = 'yam-cart-recommendation-card__variant-trigger-label';
        label.textContent = select.selectedOptions[0]?.textContent.trim() || '';
        const arrow = document.createElement('span');
        arrow.className = 'yam-cart-recommendation-card__variant-trigger-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '⌄';
        trigger.append(label, arrow);

        const menu = document.createElement('div');
        menu.className = 'yam-cart-recommendation-card__variant-menu';
        menu.setAttribute('data-yam-variant-menu', '');
        menu.setAttribute('role', 'listbox');
        menu.hidden = true;
        menu.yamWrap = wrap;
        wrap.yamMenu = menu;
        menu.addEventListener('click', (event) => {
          event.stopPropagation();
          this.onVariantMenuClick(event);
        });

        [...select.options].forEach((option) => {
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'yam-cart-recommendation-card__variant-option';
          item.setAttribute('data-yam-variant-option', option.value);
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', option.selected ? 'true' : 'false');
          item.textContent = option.textContent.trim();
          menu.append(item);
        });

        wrap.append(trigger, menu);
      });
    }

    positionVariantMenu(menu, trigger) {
      menu.style.minWidth = `${Math.max(150, trigger.getBoundingClientRect().width)}px`;
      const triggerRect = trigger.getBoundingClientRect();
      const menuRect = menu.getBoundingClientRect();
      const left = Math.min(Math.max(8, triggerRect.left), window.innerWidth - menuRect.width - 8);
      const gap = 2;
      const footerTop = document.querySelector('.yam-cart-checkout-panel')?.getBoundingClientRect().top;
      const lowerBoundary = Math.min(window.innerHeight - 8, footerTop ? footerTop - 8 : window.innerHeight - 8);
      const below = triggerRect.bottom + gap;
      const top = below + menuRect.height <= lowerBoundary
        ? below
        : Math.max(8, triggerRect.top - menuRect.height - gap);
      menu.style.left = `${left}px`;
      menu.style.top = `${top}px`;
    }

    closeVariantMenus(exceptMenu = null) {
      const menus = new Set(this.querySelectorAll('[data-yam-variant-menu]'));
      if (this.openVariantMenu) menus.add(this.openVariantMenu);
      menus.forEach((menu) => {
        if (menu === exceptMenu) return;
        menu.hidden = true;
        const wrap = menu.yamWrap || menu.closest('.yam-cart-recommendation-card__select-wrap');
        wrap?.querySelector('[data-yam-variant-trigger]')?.setAttribute('aria-expanded', 'false');
        if (wrap && menu.parentNode !== wrap) wrap.append(menu);
        menu.style.removeProperty('left');
        menu.style.removeProperty('top');
        menu.style.removeProperty('min-width');
        if (this.openVariantMenu === menu) this.openVariantMenu = null;
      });
      if (!exceptMenu) this.classList.remove('yam-cart-recommendations--menu-open');
    }

    onVariantMenuClick(event) {
      const optionButton = event.target.closest('[data-yam-variant-option]');
      if (optionButton) {
        const menu = optionButton.closest('[data-yam-variant-menu]');
        const wrap = menu?.yamWrap || optionButton.closest('.yam-cart-recommendation-card__select-wrap');
        const select = wrap?.querySelector('[data-yam-recommendation-variant]');
        const trigger = wrap?.querySelector('[data-yam-variant-trigger]');
        if (!select || !trigger) return;
        select.value = optionButton.dataset.yamVariantOption;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        trigger.querySelector('.yam-cart-recommendation-card__variant-trigger-label').textContent = optionButton.textContent.trim();
        wrap.querySelectorAll('[data-yam-variant-option]').forEach((item) => {
          item.setAttribute('aria-selected', item === optionButton ? 'true' : 'false');
        });
        this.closeVariantMenus();
        trigger.focus();
        return;
      }

      const trigger = event.target.closest('[data-yam-variant-trigger]');
      if (!trigger) return;
      const wrap = trigger.closest('.yam-cart-recommendation-card__select-wrap');
      const menu = wrap?.yamMenu || wrap?.querySelector('[data-yam-variant-menu]');
      if (!menu) return;
      const willOpen = menu.hidden;
      this.closeVariantMenus(menu);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) {
        document.body.append(menu);
        this.openVariantMenu = menu;
        menu.hidden = false;
        this.classList.add('yam-cart-recommendations--menu-open');
        this.positionVariantMenu(menu, trigger);
        menu.querySelector('[aria-selected=true]')?.focus();
      } else {
        this.closeVariantMenus();
      }
    }

    onVariantChange(event) {
      const select = event.target.closest('[data-yam-recommendation-variant]');
      if (!select) return;
      const card = select.closest('.yam-cart-recommendation-card');
      const option = select.selectedOptions[0];
      const wrap = select.closest('.yam-cart-recommendation-card__select-wrap');
      const triggerLabel = wrap?.querySelector('.yam-cart-recommendation-card__variant-trigger-label');
      if (triggerLabel && option) triggerLabel.textContent = option.textContent.trim();
      wrap?.querySelectorAll('[data-yam-variant-option]').forEach((item) => {
        item.setAttribute('aria-selected', item.dataset.yamVariantOption === select.value ? 'true' : 'false');
      });
      card?.querySelector('[data-yam-recommendation-add]')?.setAttribute('data-variant-id', select.value);
      const price = card?.querySelector('[data-yam-recommendation-price]');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      const comparePrice = card?.querySelector('[data-yam-recommendation-compare-price]');
      if (comparePrice) {
        comparePrice.textContent = option?.dataset.comparePrice || '';
        comparePrice.hidden = option?.dataset.hasComparePrice !== 'true';
      }
    }

    async onAdd(event) {
      const button = event.target.closest('[data-yam-recommendation-add]');
      if (!button || button.getAttribute('aria-busy') === 'true') return;

      button.setAttribute('aria-busy', 'true');
      if (this.status) this.status.textContent = 'Ajout du produit en cours.';

      try {
        const body = JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        });
        const config = typeof fetchConfig === 'function'
          ? { ...fetchConfig(), body }
          : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body };
        const endpoint = window.routes?.cart_add_url || '/cart/add.js';
        const response = await fetch(endpoint, config);
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || state.message || 'Ajout impossible');

        const drawer = document.querySelector('cart-drawer');
        if (drawer?.renderContents && state.sections) drawer.renderContents(state);
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'yam-cart-recommendations', cartData: state });
        }
      } catch (error) {
        button.removeAttribute('aria-busy');
        if (this.status) this.status.textContent = error.message || 'Le produit n’a pas pu être ajouté.';
        console.error('[YAM cart] Cross-sell add failed', error);
      }
    }
  }

  customElements.define('yam-cart-recommendations', YamCartRecommendations);
}

if (!window.__YAM_CART_PROMO_HELP__) {
  window.__YAM_CART_PROMO_HELP__ = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.yam-cart-promo-help');
    document.querySelectorAll('.yam-cart-promo-help[aria-expanded="true"]').forEach((openButton) => {
      if (openButton !== button) openButton.setAttribute('aria-expanded', 'false');
    });
    if (button) {
      button.setAttribute('aria-expanded', button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    }
  });
}
